import api from './api';

export const userService = {
  /**
   * Fetch all users
   * @param {Object} params - Query parameters (branch_id is optional)
   * @returns {Promise} Users list
   */
  getUsers: (params) => api.get('/auth/users/', { params }),

  /**
   * Create a new user/staff member
   * @param {Object} data - User data with email, full_name, phone, role, branch, password
   * @returns {Promise} Created user data
   */
  createUser: (data) => api.post('/auth/users/', data),

  /**
   * Get user details
   * @param {string} userId - User ID
   * @returns {Promise} User details
   */
  getUser: (userId) => api.get('/auth/users/detail/', {
    params: { user_id: userId }
  }),

  /**
   * Update user details
   * @param {string} userId - User ID
   * @param {Object} data - Updated user data (full_name, phone, role)
   * @returns {Promise} Updated user data
   */
  updateUser: (userId, data) => api.put('/auth/users/detail/', data, {
    params: { user_id: userId }
  }),

  /**
   * Delete a user
   * @param {string} userId - User ID
   * @returns {Promise} Success response
   */
  deleteUser: (userId) => api.delete('/auth/users/detail/', {
    params: { user_id: userId }
  }),

  /**
   * Toggle user active/inactive status
   * @param {string} userId - User ID
   * @returns {Promise} Updated user data
   */
  toggleUserStatus: (userId) => api.patch('/auth/users/toggle-status/', {}, {
    params: { user_id: userId }
  }),
};
